
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/layout/hex-headline.kpa`,
      template: `<div if="left" class="hex-headline left" ref="hex-headline-left">
        {{hexSvg()}}
        <h2 class="text-shadow-small">{{text}}</h2>
    </div>

    <div if="right" class="hex-headline right" ref="hex-headline-right">
        <h2 class="text-shadow-small">{{text}}</h2>
        {{(hexSvg())}}
    </div>

    <div></div>`,
      style: `@charset "UTF-8";
hex-headline {
  display: block;
  width: 100%;
}
hex-headline .hex-headline {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-bottom: var(--spacing-lg);
  /* Responsive Anpassungen */
  /* Kleine Geräte: Smartphones und kleine Tablets (bis 768px Breite) */
}
hex-headline .hex-headline h2 {
  padding: 0;
  z-index: 2;
  margin: 0;
  color: var(--accent-color);
  overflow-wrap: break-word;
  word-break: break-word;
  -webkit-hyphens: auto;
          hyphens: auto;
}
hex-headline .hex-headline .double-hex {
  position: relative;
  min-width: 80px;
}
hex-headline .hex-headline .double-hex .double-hex-svg {
  position: absolute;
  top: 0;
  width: inherit;
  height: auto;
  z-index: 1;
  transform: translateY(-50%);
}
hex-headline .hex-headline.left .double-hex {
  margin-right: 16px;
}
hex-headline .hex-headline.left .double-hex .double-hex-svg {
  left: 0;
}
hex-headline .hex-headline.left h2 {
  text-align: left;
}
hex-headline .hex-headline.right {
  justify-content: flex-end;
}
hex-headline .hex-headline.right h2 {
  text-align: right;
}
hex-headline .hex-headline.right .double-hex {
  margin-left: 16px;
}
hex-headline .hex-headline.right .double-hex .double-hex-svg {
  right: 0;
}
@media (max-width: 600px) {
  hex-headline .hex-headline .double-hex {
    display: none;
  }
}
@media (min-width: 769px) and (max-width: 1064px) {
  hex-headline .hex-headline h2 {
    font-size: 2rem;
    margin-bottom: 0.8rem;
  }
}
@media (min-width: 1200px) and (max-width: 1220px) {
  hex-headline .hex-headline h2 {
    font-size: 2.5rem;
  }
}
hex-headline .hex-headline.multiline {
  margin-bottom: var(--spacing-md);
}
hex-headline .hex-headline.multiline .double-hex {
  min-width: 80px;
}`,
      script: `(async () => { "use strict";
return {
    data: {
        lineCount: 0
    },
    props: {
        text: {
            type: String,
            default: "",
        },
        left: {
            type: Boolean,
            default: false,
        },
        right: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        hexSvg() {
            return \`
                    <span class="double-hex">
                        <svg class="double-hex-svg" width="100%" height="100%" viewBox="0 0 226 275" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;">
                            <g id="Dubble-Hex" serif:id="Dubble Hex" transform="matrix(1,0,0,1,-558,-217)">
                                <g transform="matrix(1,0,0,1,-294,-280)">
                                    <path d="M952.5,505L1045.6,558.75L1045.6,666.25L952.5,720L859.402,666.25L859.402,558.75L952.5,505Z" style="fill:none;stroke:rgb(44,65,67);stroke-width:14.69px;"/>
                                </g>
                                <g transform="matrix(1,0,0,1,-269,-236)">
                                    <path d="M952.5,505L1045.6,558.75L1045.6,666.25L952.5,720L859.402,666.25L859.402,558.75L952.5,505Z" style="fill:none;stroke:rgb(100,193,108);stroke-width:14.69px;"/>
                                </g>
                            </g>
                        </svg>
                    </span>
                \`;
        },
        getLineCount(element) {
            const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
            const elementHeight = element.offsetHeight;
            return Math.round(elementHeight / lineHeight);
        },
        toggleMultiline() {
            const side = this.left ? 'left' : (this.right ? 'right' : null);
            if (!side)
                return;
            const container = $refs[\`hex-headline-$-{side}\`];
            if (!container)
                return;
            const heading = container.querySelector('h2');
            if (!heading)
                return;
            this.lineCount = this.getLineCount(heading);
            if (this.lineCount > 1) {
                container.classList.add('multiline');
            }
            else {
                container.classList.remove('multiline');
            }
        },
    },
    events: [
        ['resize', window, function (event) {
                this.toggleMultiline();
            }],
    ],
    mounted() {
        const run = () => this.toggleMultiline();
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(run);
        }
        else {
            requestAnimationFrame(run);
        }
    }
};
 })()`
    };
  